// src/hooks/useTestimonials.js
import { useState, useEffect, useCallback } from 'react';

function calcSatisfaction(testimonials) {
  if (!testimonials.length) return 100;
  const satisfied = testimonials.filter(t => t.rating >= 4).length;
  return Math.round((satisfied / testimonials.length) * 100);
}

export function useTestimonials() {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const res = await fetch('/api/testimonials');
      if (res.ok) {
        const data = await res.json();
        setTestimonials(data);
      }
    } catch {
      // keep current state
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  async function addTestimonial({ name, role, body, rating }) {
    try {
      const res = await fetch('/api/testimonials', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, role, body, rating }),
      });
      if (res.ok) {
        const newT = await res.json();
        setTestimonials(prev => [...prev, newT]);
      }
    } catch {
      // silent fail
    }
  }

  async function removeTestimonial(id, authFetch) {
    try {
      if (authFetch) {
        const updated = await authFetch('/api/admin/testimonials', {
          method: 'DELETE',
          body: { id },
        });
        setTestimonials(updated);
      } else {
        setTestimonials(prev => prev.filter(t => t.id !== id));
      }
    } catch {
      // silent fail
    }
  }

  return {
    testimonials,
    loading,
    addTestimonial,
    removeTestimonial,
    satisfaction: calcSatisfaction(testimonials),
    refresh,
  };
}
